export default "__VITE_ASSET__ef802abc__"